import { Hidden, makeStyles } from "@material-ui/core";
import { useEffect } from "react";
import history from "../../history";

const useStyles = makeStyles((theme) => ({
  precisaAjuda: {
    fontSize: '1.2em',
    lineHeight: '1.1em',
    color: '#333',
    fontWeight: 'bold',
    top: '10px',
    margin: '0',
    position: 'inherit',
    paddingBottom: '16px'
  },
  iconOutrosCanais: {
    display: 'flex',
    alignItems: 'center',
    marginRight: '16px',
    fontSize: '24px',
    color: theme.overrides.AjudaHelo.buttonColor,
    [theme.breakpoints.up('sm')]: {
      marginBottom: '8px',
      height: 'calc(90%)',
      alignItems: 'end'
    },
  },
  textDescHelo: {
    margin: '4px 0 16px',
    [theme.breakpoints.up('sm')]: {
      margin: '4px 0 16px'
    },
  },
  imgHelo: {
    width: '66px',
    [theme.breakpoints.up('sm')]: {
      width: '80px',
    },
    borderRadius: '32px'
  },
  divAngleRight: {
    display: 'flex',
    height: 'calc(90%)',
    marginBottom: '8px',
    alignItems: 'end',
    marginRight: '16px',
    fontSize: '24px',
    color: theme.overrides.AjudaHelo.buttonColor,
  },
  inicarAtendimentoTextButton: {
    color: theme.overrides.AjudaHelo.buttonColor,
  },
  gridCardAjuda: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row'
    },
    gap: '16px',
  },
  cardAjuda: {
    padding: '5px 0',
    [theme.breakpoints.down('xs')]: {
      width: '100%'
    },
    width: 'calc(100% - 8px)',
    borderRadius: '5px',
    height: '8.571em',
    backgroundColor: theme.overrides.AjudaHelo.backgroundColor,
    cursor: 'pointer',
    [theme.breakpoints.up('sm')]: {
      width: 'calc(50% - 8px)',
    },
    '&:hover': {
      background: theme.palette.mode === 'dark' ? '' : 'rgba(230, 230, 230, .8)',
    },
    '&:focus': {
      boxShadow: '0 0 0 2px #c2850c',
      border: '1px solid #c2850c',
      outline: 'none'
    },
    '&:last-child': {
      [theme.breakpoints.down('xs')]: {
        height: '56px',
      }
    }
  },
  tituloCard: {
    fontSize: '1.2em',
    fontFamily: 'RawlineSemibold, Rawline',
    [theme.breakpoints.down('xs')]: {
      fontSize: '1em'
    }
  }
}))

const IMG_HELO = 'https://prd-inss-omniv2-attachments.s3.us-east-2.amazonaws.com/assistants/6c150583-9bd3-4b33-89de-c21178a93043/webchannels/7e1188ab-82da-4e59-ac04-599d08af37c8/desktop-avatar-button?1740737740096'

export const CardsAjuda = ({ rotaCanaisAjuda }) => {

  const classes = useStyles();

  return (
    <div style={{ display: 'flex', flexDirection: 'column', paddingBottom: '16px' }}>
      <h2 className={classes.precisaAjuda}>
        {"Precisa de ajuda?"}
      </h2>
      <div className={classes.gridCardAjuda}>
        <CardHelo />

        <CardCanaisAjuda
          onClick={() => {
            if (rotaCanaisAjuda) {
              history.push(rotaCanaisAjuda)
            }
          }}
        />
      </div>
    </div>
  )
}

export const CardCanaisAjuda = ({ onClick }) => {

  const classes = useStyles();

  const handleClick = () => {
    if (onClick) onClick();
  }

  const handleKeyDown = (e, callback) => {
    if (e.key === 'Enter') {
      callback();
    }
  };

  return (
    <div
      role="button"
      tabIndex={0}
      className={classes.cardAjuda}
      style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}
      onClick={() => handleClick()}
      onKeyDown={(e) => handleKeyDown(e, handleClick)}
      aria-labelledby="ajuda-title-canais ajuda-description-canais"
      >
      <div style={{ display: 'flex', flexDirection: 'column', flexGrow: '1', marginLeft: '16px' }}>
        <div>
          <span id="ajuda-title-canais" className={classes.tituloCard}>{"Outros canais de Ajuda"}</span>
        </div>
        <Hidden xsDown>
          <div style={{ margin: '4px 0 36px' }}>
            <span id="ajuda-description-canais" >{"Encontre uma agência, Perguntas frequentes, Ouvidoria"}</span>
          </div>
        </Hidden>
      </div>
      <div className={classes.iconOutrosCanais}>
        <i className="fas fa-angle-right"></i>
      </div>
    </div>
  )
}

export const CardHelo = () => {

  let chatBot = document.getElementById("omni-chat-web");
  let closeChat = null;

  const classes = useStyles();

  const handleOpenChat = () => {
    if (chatBot) {
      chatBot.style.display = "";
      chatBot.style.zIndex = "9999";
      chatBot.style.position = "fixed";
      const openChat = document.getElementById("omni-show-chat");
      if (openChat) {
        openChat.click();
        
        setTimeout(() => {
          const startButton = chatBot.querySelector(".br-button.omni-button")
          const nameInput = chatBot.querySelector("#userNameForm")

          if (nameInput) {
            nameInput.focus()
          }else if (startButton) {
            startButton.focus()
          }else{
            console.log("Botão iniciar chat não encontrado");
          }
        }, 200)

        closeChat = chatBot.querySelector(".close-btn-eds");
        if (closeChat) {
          closeChat.addEventListener("click", handleCloseChat);
        }
      }
    }
  }

  const handleCloseChat = () => {
    let chat = document.getElementById("omni-chat-web");
    if (chat) chat.style.display = 'none';
  }

  const handleKeyDown = (e, callback) => {
    if (e.key === 'Enter') {
      callback();
    }
  };

  useEffect(() => {
    if (chatBot) {
      chatBot.style.display = "none";
    } else {
      console.log("div omni-chat-web não foi localizado");
    }

    return () => {
      if (chatBot) chatBot.style.display = "";
    }
  }, [])

  return (
    <div
      role="button"
      tabIndex={0}
      className={classes.cardAjuda}
      style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}
      onClick={() => handleOpenChat()}
      onKeyDown={(e) => handleKeyDown(e, handleOpenChat)}
      aria-labelledby="ajuda-title-helo ajuda-description-helo"
    >
      <div style={{ borderRadius: '10px', margin: '0px 16px' }}>
        <img className={classes.imgHelo} src={IMG_HELO} alt="" />
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', flexGrow: '1' }}>
        <div>
          <span id="ajuda-title-helo" className={classes.tituloCard}>{"Converse com a Helô"}</span>
        </div>
        <div className={classes.textDescHelo}>
          <span id="ajuda-description-helo" >{"Olá, sou a assistente virtual do INSS"}</span>
        </div>
        <div className={classes.inicarAtendimentoTextButton} style={{ display: 'flex', justifyContent: 'end', marginRight: '16px' }}>
          <span aria-hidden="true" style={{ fontWeight: 'bold' }}>{"Iniciar Atendimento"}</span>
          <i style={{ display: 'flex', justifyContent: 'end', alignItems: 'end' }} className="fas fa-angle-right"></i>
        </div>
      </div>
    </div>
  )
}